import { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { ArrowLeft, ExternalLink } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function RedocDocsPage() {
  const [iframeUrl, setIframeUrl] = useState('');

  const initializeUrl = useCallback(() => {
    setIframeUrl(`${API_URL}/api/redoc`);
  }, []);

  useEffect(() => {
    initializeUrl();
  }, [initializeUrl]);

  return (
    <div className="min-h-screen bg-gray-900 flex flex-col">
      {/* Header */}
      <header className="bg-gray-800 border-b border-gray-700 p-4 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Link to="/admin/api-docs">
            <Button variant="ghost" size="sm" className="text-gray-300 hover:text-white">
              <ArrowLeft className="h-4 w-4 mr-2" />
              Volver
            </Button>
          </Link>
          <div>
            <h1 className="text-lg font-bold text-white">ReDoc</h1>
            <p className="text-xs text-gray-400">Documentación de OkReserva API</p>
          </div>
        </div>
        <a href={`${API_URL}/api/redoc`} target="_blank" rel="noopener noreferrer">
          <Button variant="outline" size="sm" className="gap-2">
            <ExternalLink className="h-4 w-4" />
            Abrir en nueva pestaña
          </Button>
        </a>
      </header>
      
      {/* Iframe */}
      <div className="flex-1">
        {iframeUrl ? (
          <iframe 
            src={iframeUrl}
            className="w-full h-full border-0"
            title="ReDoc"
            style={{ minHeight: 'calc(100vh - 73px)' }}
          />
        ) : (
          <div className="flex items-center justify-center h-full">
            <div className="text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500 mx-auto mb-4"></div>
              <p className="text-white">Cargando ReDoc...</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
